module.exports = __webpack_public_path__ + "public/img/energy2.0e88ac04.png";